import { UserAttributeDefs } from '../types/ModelTypes'
import { Person, type PersonType } from './Person'

const typeName = 'User'

export type UserType = PersonType & {
  type: typeof typeName
  username: string
  temporaryPassword?: string
  last_login?: number
  IdentityId?: string
}

class User extends Person implements UserType {
  constructor(pob: UserType) {
    if (pob.type !== typeName) throw new Error('Tried to construct a User from a non-User object!')
    super(pob) // can't use this.constructor.name as will fail in lambda as gets Class name appended twice
    
    this.type = pob.type
    this.username = pob.username
    this.last_login = pob.last_login
    this.IdentityId = pob.IdentityId
  }

  type: typeof typeName
  username: string
  temporaryPassword?: string | undefined
  last_login?: number | undefined
  IdentityId?: string | undefined

  getUserAttributes(): UserAttributeDefs {
    return {
      username: {
        type: 'String',
        label: 'Username',
        editable: false,
        required: true,
      },
      ...super.getUserAttributes(),
      last_login: {
        type: 'Date',
        label: 'Last login',
        editable: false,
        required: false,
      },

      /** 2024 02 removed as replaced in edgeTypeMatrix */
      // Customer: {
      //   type: 'RelatedType',
      //   direction: PathDirection.parent,
      //   edgeTypeId: 'customer_has_users',
      //   editable: false,
      // },
    }
  }
}

export { User }
